import React from 'react';
import { Box, Button, Typography, Select, MenuItem, IconButton } from '@mui/material';
import { themeColors } from '../theme';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const Pagination = ({
    page,
    setPage,
    pageSize,
    setPageSize,
   count
}: any) => {
    // const pageCount = Math.ceil(count / pageSize);

    const handlePageSizeChange = (value:any) => {
        setPageSize(value);
    };

    const handlePagePrevious = () => {
        setPage(page - 1>=0?page - 1:0);
    };

    const handlePageNext = () => {
        setPage(page + 1);
    };
    //   const handleRowsPerPageChange = (event) => {
    //     onChangeRowsPerPage(parseInt(event.target.value, 10));
    //     onChangePage(0);
    //   };

    return (
        <Box sx={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', padding: 2, backgroundColor: themeColors.thBackgroundColor }}>
            <Box />
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography>
                    Page: {page + 1}
                </Typography>
                <Box marginLeft={2}>
                    <Select
                        value={pageSize}
                        sx={{ width: "100px", height: "40px" }}
                      onChange={(e:any)=>{
                        handlePageSizeChange(e.target.value);
                      }}
                    >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                        {/* Add more options as needed */}
                    </Select>
                </Box>
                <IconButton aria-label="go to previous page" sx={{ marginLeft: 2 }} onClick={handlePagePrevious} 
                // disabled={page >= pageCount - 1}
                >
                    <KeyboardArrowLeftIcon />
                </IconButton>
                <IconButton aria-label="go to next page" onClick={handlePageNext}
                //  disabled={page >= pageCount - 1}
                 >
                    <KeyboardArrowRightIcon />
                </IconButton>
            </Box>
            <Typography>
                Total Records: {count}
            </Typography>
        </Box>
    );
};

export default Pagination;
